import React, { useState } from 'react';
import { Box, Button, TextField, Typography, IconButton, Tooltip, CircularProgress, Alert } from '@mui/material';
import { Copy, Save, CheckCircle } from 'lucide-react';
import api from '../config/axios';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
    const [amazonCookies, setAmazonCookies] = useState('');
    const [isTesting, setIsTesting] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleCopy = () => {
        navigator.clipboard.writeText(amazonCookies);
    };

    const handleSave = async () => {
        try {
            await api.post('/api/settings/cookies', { cookies: amazonCookies });
            setError(null);
        } catch (err) {
            setError("Erreur lors de la sauvegarde des cookies");
        }
    };

    const handleTest = async () => {
        setIsTesting(true);
        setTestResult(null);
        setError(null);
        try {
            await api.post('/api/settings/test-cookies');
            setTestResult('success');
        } catch (err) {
            setTestResult('error');
            setError("Erreur lors du test des cookies");
        } finally {
            setIsTesting(false);
        }
    };

    const handleAmazonConnect = async () => {
        try {
            const { data } = await api.get('/api/amazon/oauth/login');
            if (data.url) {
                window.location.href = data.url;
            }
        } catch (err) {
            setError("Erreur lors de la génération de l'URL Amazon OAuth2");
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
                Paramètres
            </Typography>
            <Box sx={{ mt: 2 }}>
                <TextField
                    label="Cookies Amazon"
                    multiline
                    rows={4}
                    value={amazonCookies}
                    onChange={(e) => setAmazonCookies(e.target.value)}
                    fullWidth
                    variant="outlined"
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Tooltip title="Copier les cookies">
                            <IconButton onClick={handleCopy} color="primary">
                                <Copy size={20} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Sauvegarder les cookies">
                            <IconButton onClick={handleSave} color="primary">
                                <Save size={20} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Tester les cookies">
                            <IconButton 
                                onClick={handleTest} 
                                color={testResult === 'success' ? 'success' : 'primary'}
                                disabled={isTesting}
                            >
                                {isTesting ? <CircularProgress size={24} /> : <CheckCircle size={20} />}
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button 
                        variant="outlined" 
                        color="primary" 
                        onClick={handleTest}
                        disabled={isTesting || !amazonCookies}
                        startIcon={isTesting ? <CircularProgress size={20} /> : <CheckCircle size={20} />}
                    >
                        {isTesting ? 'Test en cours...' : 'Tester les cookies'}
                    </Button>
                </Box>
                <Box sx={{ mt: 4 }}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                        Pour connecter votre compte Amazon, vous serez redirigé vers Amazon Seller Central afin d'autoriser l'accès à l'application. Après validation, vous serez automatiquement ramené ici.
                    </Alert>
                    <Button variant="contained" color="secondary" onClick={handleAmazonConnect}>
                        Connecter mon compte Amazon
                    </Button>
                </Box>
                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
            </Box>
        </Box>
    );
};

export default Settings; 